import moment from 'moment-timezone'
import axios from 'axios'
import store from '../store/index.js'
import router from '../router'
import accounting from 'accounting'
import { post, get } from '../services/index.js'
import config from '@/config/index.js'
import Vue from 'vue'
import Compressor from 'compressorjs';
import imageCompression from 'browser-image-compression';
import html2canvas from 'html2canvas';
import { classifyTagIds } from './googleTag';
import { openAuthModal, closeAuthModal, setAuthView } from './authModal.js';
import { track, trackRoomSearch, appendVisitorParam } from './tracker.js';
const { helpers } = require("vuelidate/lib/validators");

const JOKUL_SCRIPT_ID = 'jokul-url'
const CENT_FACTOR = 100
const LEGACY_CURRENCY_API = 'https://api.guestpro.net/api/currencyconverterapi/'
const LEGACY_DEFAULT_BASE_CURRENCY = 'IDR'

const buildCurrencyRate = (rate, type) => ({ a: rate, b: 1 / rate, type })

const fetchMerchantCurrencyRate = (merchantId, to) => {
  return get('CORE_HOTEL', 'currency-rates', { merchant_id: merchantId }).then(response => {
    const rates = (response.data && response.data.data && response.data.data.rates) || []
    const matchedRate = rates.find(item => item.code === to)
    const rate = matchedRate ? Number(matchedRate.bookeepingrate) : 0
    if (!(rate > 0)) throw new Error(`Currency rate ${to} not available`)

    return buildCurrencyRate(rate, matchedRate.type)
  })
}

// Konteks tanpa merchant (community/affiliate) belum punya merchant_id untuk endpoint currency-rates
const fetchLegacyCurrencyRate = (from, to) => {
  const fetchPair = (pair) => axios.get(`${LEGACY_CURRENCY_API}${pair}`).then(response => {
    const results = response.data && response.data.results
    const rate = results && results[pair] ? Number(results[pair].val) : 0
    if (!(rate > 0)) throw new Error(response.data && response.data.error || `Currency rate ${pair} not available`)
    return rate
  })

  return Promise.all([fetchPair(`${from}_${to}`), fetchPair(`${to}_${from}`)])
    .then(([rate, inverseRate]) => ({ a: rate, b: inverseRate, type: 'MARKET' }))
}

const fetchCurrencyRate = (to) => {
  const isMerchant = store.getters.getCompanyType == 'MERCHANT'
  const { id: merchantId, base_currency_code: merchantBaseCurrency } = store.getters.getMerchant
  const baseCurrency = isMerchant ? merchantBaseCurrency : LEGACY_DEFAULT_BASE_CURRENCY

  if (to === baseCurrency) return Promise.resolve(buildCurrencyRate(1, 'BASE'))
  if (isMerchant && merchantId) return fetchMerchantCurrencyRate(merchantId, to)
  return fetchLegacyCurrencyRate(baseCurrency, to)
}

const buildCommunityLoginUrl = (CURRENT_ORIGIN, COMMUNITY_ORIGIN) => {
  const origin = `origin=${encodeURIComponent(CURRENT_ORIGIN)}`;

  const { name, id } = store.getters.getMerchant;
  const merchantName = `merchant=${encodeURIComponent(name)}`;
  const merchantId = `merchant_id=${encodeURIComponent(id)}`;

  return appendVisitorParam(`${COMMUNITY_ORIGIN}/login?${origin}&${merchantName}&${merchantId}`);
}
const onMessageFromCommunityAuth = async (event, COMMUNITY_ORIGIN, authPopup) => {
  try {
    const expectedOrigin = new URL(COMMUNITY_ORIGIN).origin
    if (event.origin !== expectedOrigin) return
    if (event.source !== authPopup) return

    const { access_token: access, refresh_token: refresh, user } = event.data || {}
    if(!access || !refresh || !user) throw new Error("Data not found")

    store.dispatch('setToken', {access, refresh});
    store.dispatch('setUser', user);

    if(authPopup) authPopup.close()

    await getUserDetail();

    window.location.reload()
  } catch (error) {
    throw error.message;
  }
}
const getUserDetail = async () => {
  try {
    const { id: merchant_id } = store.getters.getMerchant;
    const apiResponse = await get("CONCIERGE", "membership/user-member-card-detail", {merchant_id})
    const { success, data, message } = apiResponse.data
    if(!success) throw new Error(message);
    return data;
  } catch (error) {
    throw error;
  }
}

export default{
	// DATA
	$directbooking_favicon:'https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Eo_circle_blue_letter-b.svg/1200px-Eo_circle_blue_letter-b.svg.png',
	$freeScrollSliderOption:{
		initialIndex: 0,
    autoPlay: 5000,
    prevNextButtons: false,
    pageDots: false,
    adaptiveHeight: false,
    draggable: true,
    wrapAround: false,
    contain: true
	},
	$fullSliderOption: {
    initialIndex: 0,
    autoPlay: 3000,
    prevNextButtons: false,
    pageDots: false,
    adaptiveHeight: false,
    draggable: true,
    wrapAround: true,
  },
	$basic_slider_option:{
		initialIndex: 0,
		autoPlay: 3000,
		prevNextButtons: false,
		pageDots: true,
		adaptiveHeight: false,
		draggable: false,
		wrapAround: true,
	},
  $app_env: config.ENV,
	$is_mobile_view: window.innerWidth >= 768 ? false : true,
	$is_tablet_lower_view: window.innerWidth < 992,
	$conciergeAvlbPayment: [
		{
			bank_name: 'JOKUL_DOKU',
			payment_method: ['VIRTUAL_ACCOUNT','CREDIT_CARD']
		},
		{
			bank_name: 'MIDTRANS',
			payment_method: ['VIRTUAL_ACCOUNT','CREDIT_CARD']
		},
		{
			bank_name: 'XENDIT',
			payment_method: ['VIRTUAL_ACCOUNT','CREDIT_CARD','QRIS']
		},
		// {
		// 	bank_name: 'IPAYMU',
		// 	payment_method: ['VIRTUAL_ACCOUNT','CREDIT_CARD','QRIS']
		// },
		{
			bank_name: 'DIRECT_PAYMENT',
			payment_method: ['QRIS','BANK_TRANSFER']
		},
    {
			bank_name: 'FLYWIRE',
			payment_method: ['CREDIT_CARD']
		},
    {
			bank_name: 'RAZORPAY_CURLEC',
			payment_method: ['CREDIT_CARD', 'DIRECT_DEBIT']
		},
    {
			bank_name: 'PIVOT',
			payment_method: ['CREDIT_CARD', 'VIRTUAL_ACCOUNT', 'QRIS']
		}
	],

	// FUNCTION
	$startDate: function(date=null,format='day'){
		let data = date == null ? moment() : moment(date);
		return moment(data).startOf(format).toDate();
	},
	$endDate: function(date=null,format='day'){
		let data = date == null ? moment() : moment(date);
		return moment(data).endOf(format).toDate();
	},
	$defaultFilterBE: function(type){
		let merchant_type_data = typeof store.getters.getMerchant
		if(merchant_type_data == 'object' && Object.keys(store.getters.getMerchant).length > 0){
			return type == 'night' ? store.getters.getMerchant.search_room_filter_default_total_night : store.getters.getMerchant.search_room_filter_default_total_adult
		}else{
			return type == 'night' ? 1 : 2
		}
	},
	$createUUID: function(){
		return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
	    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	  );
	},
	$formatCurrency: function(value,no_base_rate=false,real_time=false,currency,base_price, isMasked = false){
		var options={
	    symbol: (real_time) ? currency.symbol_native : store.getters.getCurrency.symbol_native,
	    precision: (real_time) ? currency.digit : store.getters.getCurrency.digit
	  }


	  let cal_val = (real_time) ? base_price * value : store.getters.getBaseRate.a * value

	  if(no_base_rate) cal_val = value
    const formatted = accounting.formatMoney(cal_val, options);

    if(!isMasked) return formatted;

    let chars = formatted.split("")
    let digitIndexes = chars
      .map((c, i) => (/[0-9]/.test(c) ? i : -1))
      .filter(i => i !== -1)

    const maskCount = Math.max(1, Math.floor(digitIndexes.length * 0.6))

    let protect = [digitIndexes[0], digitIndexes[digitIndexes.length - 1]]
    let candidates = digitIndexes.filter(i => !protect.includes(i))

    let maskedIndexes = []
    while (maskedIndexes.length < maskCount && candidates.length > 0) {
      let idx = candidates[Math.floor(Math.random() * candidates.length)]
      if (!maskedIndexes.includes(idx)) maskedIndexes.push(idx)
    }

    maskedIndexes.forEach(i => {
      chars[i] = "*"
    })

    return chars.join("")
	},
	$formatCurrencyCustom: function(type='price',value){
	  if(type == 'price'){
	  	return store.getters.getBaseRate.a * value
	  }else{
	  	return store.getters.getCurrency.code
	  }
	},
	$formatCurrencyCompact: (value) => {
		let formatter = Intl.NumberFormat(this.getCurrentLanguage, { notation: 'compact' })
		return formatter.format(value)
	},
  $formatCurrencyCompactParts: (value) => {
		let formatter = Intl.NumberFormat(this.getCurrentLanguage, { notation: 'compact' })
		const parts = formatter.formatToParts(value)
    const getPart = (type, fallback) => {
      if(type === 'number'){
        return parts
        .filter(p => p.type === 'integer' || p.type === 'decimal' || p.type === 'fraction')
        .map(p => p.value)
        .join('')
      }

      const part = parts.find(p => p.type === type)
      return part ? part.value : fallback
    }
    return {
      number: getPart ('number', 0),
      compact: getPart ('compact', ""),
    }
	},
	$formatDate: function(date,format_from=''){
	  if (!date){
	    return ''
	  }else{
	  	let final_date = format_from == '' ? moment(date) : moment(date,format_from)
	    if (store.getters.getCurrentLanguage == '') {
	      return moment(final_date).format('ddd, DD MMM YYYY');
	    }else{
	      return moment(final_date).locale(store.getters.getCurrentLanguage).format('ddd, DD MMM YYYY');
	    }
	  }
	},
	$formatDateApi: (date,is_reverse=false,withTime=false) => {
		if(!date) return '';

		const DEFAULT_FORMAT = withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
		if(is_reverse) return moment(date,DEFAULT_FORMAT).toDate();
		return moment(date).format(DEFAULT_FORMAT);
	},
	$formatDateTime: function(date, useTimeZone=false, use24hour = false){
	  if (!date){
	    return ''
	  }else{
      const formatDate = use24hour ? 'MMM D, YYYY, HH:mm': 'MMM D, YYYY, hh:mm A'
	    if (store.getters.getCurrentLanguage == '') {
        if(useTimeZone) return moment(date).tz(store.getters.getMerchantTimezone.name).format(formatDate);
	      return moment(date).format(formatDate);
	    }else{
        if(useTimeZone) return moment(date).tz(store.getters.getMerchantTimezone.name).locale(store.getters.getCurrentLanguage).format(formatDate);
	      return moment(date).locale(store.getters.getCurrentLanguage).format(formatDate);
	    }
	  }
	},
	$formatDateWithoutMonth: function(date){
	  if (!date){
	    return ''
	  }else{
	    if (store.getters.getCurrentLanguage == '') {
	      return moment(date).format('ddd, DD MMM');
	    }else{
	      return moment(date).locale(store.getters.getCurrentLanguage).format('ddd, DD MMM');
	    }
	  }
	},
	$formatDateRange: function(start=null,end=null,format_start=null,format_end=null){
	  if (start == null || end == null){
	    return ''
	  }else{
			let date = {
				day:{
					start: format_start == null ? moment(start).format("D") : moment(start,format_start).format("D"),
					end: format_end == null ? moment(end).format("D") : moment(end,format_end).format("D")
				},
				month:{
					start: format_start == null ? moment(start).format("MMM") : moment(start,format_start).format("MMM"),
					end: format_end == null ? moment(end).format("MMM") : moment(end,format_end).format("MMM")
				},
				year:{
					start: format_start == null ? moment(start).format("YYYY") : moment(start,format_start).format("YYYY"),
					end: format_end == null ? moment(end).format("YYYY") : moment(end,format_end).format("YYYY")
				}
			}
			if(date.year.start == date.year.end){
				if(date.month.start == date.month.end){
					return `${date.month.start} ${date.day.start} - ${date.day.end}`
				}else{
					return `${date.month.start} ${date.day.start} - ${date.month.end} ${date.day.end}`
				}
			}else{
				return `${date.month.start} ${date.day.start}, ${date.year.start} - ${date.month.end} ${date.day.end}, ${date.year.end}`
			}
	  }
	},
	$customFormatDateTime: function(date,date_desc='null',moment_string="DD MMM YYYY, h:mm a"){
		if (!date) return ''
		else{
			if (store.getters.getCurrentLanguage == ''){
				if (date_desc=='null') return moment(date).format(moment_string)
				return moment(date,date_desc).format(moment_string)
			}else{
				if (date_desc=='null') return moment(date).locale(store.getters.getCurrentLanguage).format(moment_string)
				return moment(date,date_desc).locale(store.getters.getCurrentLanguage).format(moment_string)
			}
		}
	},
	$track: function(name, props = {}, options = {}){
		track(name, props, options)
	},
	$trackRoomSearch: function(){
		trackRoomSearch()
	},
	$trackHomeClick: function(section, label){
		// HOME keeps the v1 module for navbar/footer clicks rendered on non-home pages.
		track('click', { section, label, legacy_module: 'HOME' })
	},
	$calculateFinalPriceConcierge: function(price){
		if(price.tax_service_calculation_type == 'EXCLUDE'){
	    if(parseInt(price.promotion_amount) == 0){
	      return price.price_sell
	    }else{
	      return price.price_sell_final
	    }
	  }else{
	    return price.price_sell_final_with_tax_service
	  }
	},
	$getDeviceType: function(){
  	const ua = navigator.userAgent;
	  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
	    return "Tablet";
	  }
	  if (
	    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
	      ua
	    )
	  ) {
	    return "Mobile";
	  }
	  return "Desktop";
  },
  $checkDuration: function(time,duration_value,duration_type,time_format=null){
  	let past = time_format == null ? moment(time).format() : moment(time,time_format).format()
		let now = moment().format()
		let result = moment.duration(moment(now).diff(moment(past)))
		let result_value = 0
		if(duration_type == 'milliseconds'){
			result_value = result.asMilliseconds()
		}else if(duration_type == 'seconds'){
			result_value = result.asSeconds()
		}else if(duration_type == 'minutes'){
			result_value = result.asMinutes()
		}else if(duration_type == 'hours'){
			result_value = result.asHours()
		}else if(duration_type == 'days'){
			result_value = result.asDays()
		}else if(duration_type == 'weeks'){
			result_value = result.asWeeks()
		}else if(duration_type == 'months'){
			result_value = result.asMonths()
		}else if(duration_type == 'years'){
			result_value = result.asYears()
		}else{
			result_value = result.asHours()
		}
		return result_value > duration_value ? true : false
  },
  $getHotelModuleFromRouter: function(router_name){
  	let modules_list = [
  		{
  			module_name : 'BOOKING_ENGINE',
  			page_list: [
  				'BERoom',
  				'BePaymentResult',
  				'BeConfirmPayment',
  				'BeDirectFilter',
  				'BeDirectDetail',
  				'BeDirectPromo',
  				'BeOrderHistory'
  			]
  		},
  		{
  			module_name : 'CONCIERGE',
  			page_list:[
  				'ConciergeMainPage',
  				'ConciergeDirectAuth',
  				'PreCheckinRoomList',
  				'PreCheckinForm',
  				'MaintenanceService',
  				'ConciergeInquiry',
  				'ConciergePaymentResult',
  				'ConciergeOrder',
  				'ConciergeChat',
  				'ConciergeRoomDining',
  				'ConciergeRoomDiningCart',
  				'ConciergeRoomDiningSuccess',
  				'ConciergeSpa',
  				'ConciergeSpaCart',
  				'ConciergeSpaSuccess',
  				'ConciergeSpaSelect',
  				'ConciergeExtraAmenities',
  				'ConciergeExtraAmenitiesCart',
  				'ConciergeExtraAmenitiesSuccess',
  				'ConciergeLaundry',
  				'ConciergeLaundryCart',
  				'ConciergeLaundrySuccess',
  				'ConciergeNotification',
  				'ConciergeMember',
  				'ConciergeAccount',
  				'ConciergePersonalData',
  				'ConciergeLanguage',
  				'ConciergeHelp',
  				'ConciergeThingsToDo',
  				'ConciergeThingsToDoProductList',
  				'ConciergeThingsToDoCart',
  				'ConciergeThingsToDoDetail',
  				'BeModuleServiceTrxResult'
  			]
  		},
  		{
  			module_name : 'CONCIERGE',
  			page_list: [
  				'GroupVoucher',
  				'GroupVoucherCart',
  				'GroupVoucherBookingResult'
  			]
  		}
  	]

  	let result_index = modules_list.findIndex(x=> x.page_list.some(y=>y==router_name))
  	if(result_index != -1){
  		return modules_list[result_index].module_name
  	}else{
  		return 'MODULE NOT FOUND'
  	}
  },
  $copyText: function(text,success_message="Successful copy"){
    navigator.clipboard.writeText(text);
    this.$notify({
		  title: 'Share',
		  type: 'success',
		  position: 'top left',
		  text: success_message
		});
  },
  $capitalize: function(text,is_each_word=false){
  	if(!is_each_word){
  		let return_data = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  		return return_data
  	}else{
  		const splitted_text = text.split(" ")
  		for (var i = 0; i < splitted_text.length; i++) {
			  splitted_text[i] = splitted_text[i].charAt(0).toUpperCase() + splitted_text[i].slice(1).toLowerCase()
			}
			return splitted_text.join(" ")
  	}
  },
  $pluralWord: function(counter,word){
  	if(Number(counter) > 1){
  		return word+"s"
  	}else{
  		return word
  	}
  },
  $getPercentage: function(big,small,to_fixed=2){
  	let res = (small/big)*100
		return +parseFloat(res).toFixed(to_fixed)
  },
  $openLink: function(url,target='default'){
  	let tag_a = document.createElement('a')
		tag_a.href = url
  	if(target != 'default'){
			tag_a.target = target
  	}
		tag_a.click()
		tag_a.remove()
  },
  $getReservationFromAuth: function(){
  	return new Promise((success,fail)=>{
  		get("CONCIERGE",'reservation',{
				merchant_id: store.getters.getMerchant.id,
				status: 'NEW_RESERVATION,SUBMIT_FORM,PRE_CHECKIN,CHECKIN,CHECKOUT,CANCELLED',
				datetime_type: 'NO_USE_FILTER_DATE',
				start_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
				end_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
				page_size: 100,
				page: 1
			}).then(response=>{
				let res = response.data
				if(res.success){
					let total_active_reservation = res.data.filter(x=>{
						if(Vue.prototype.$isReservationValid(x)){
							return x
						}
					})
					success(total_active_reservation)
				}else{
					fail(res.message)
				}
			})
  	})
  },
	$isReservationValid: function(rsv){
		let is_status_off = rsv.status == 'NEW_RESERVATION' || rsv.status == 'CHECKOUT' || rsv.status == 'CANCELLED'
		let today_end = moment().endOf("day").toDate()
		let invalid_departure_date_end = moment(rsv.departure_date,'YYYY-MM-DD').endOf("day").toDate()
		let invalid_departure_date = moment(today_end).isAfter(invalid_departure_date_end)

		return !is_status_off && !invalid_departure_date
	},
  $logout: function(){
  	store.dispatch("logout")
  	if(store.getters.getMerchant.merchant_type == 'hotel'){
  		store.commit("resetConciergeAuth")
  	}
  },
  $openAuthModal: function(config){
    openAuthModal(config)
  },
  $closeAuthModal: function(){
    closeAuthModal()
  },
  $setAuthView: function(view){
    setAuthView(view)
  },
  $smoothScroll: function(dom_id,block='start'){
    const element = document.getElementById(dom_id);
    if(element){
      element.scrollIntoView({
        behavior: 'smooth',
        block: block
      });
    }
  },
	// $smoothScrollDetail: function(dom_id,offset){
  // 	let el = document.getElementById(dom_id)
	// 	let top = el.getBoundingClientRect().top-offset
	// 	el.scroll({
	// 		top: 300,
	// 		left: 0,
	// 		behavior: 'smooth'
	// 	})
	// 	console.log("TOP : ", top)
  // },
  $roomAvbl: function(room_type_id,room_rate_id,limit=false){
	  let room_type_index = store.getters.getBeRoomAvbl.findIndex(x=>x.id == room_type_id)
	  if(room_type_index != -1){

	    let room_rate_index = store.getters.getBeCartRoom.findIndex(x=>x.room_rate.id == room_rate_id)
	    let avlb = store.getters.getBeRoomAvbl[room_type_index].availability

	    if(room_rate_index != -1){
	      avlb = store.getters.getBeCartRoom[room_rate_index].qty + store.getters.getBeRoomAvbl[room_type_index].availability
	    }

	    if(limit){
	      return (avlb < 6) ? avlb : 6
	    }else{
	      return avlb
	    }
	  }else{
	    return 0
	  }
	},
	$loadAgentDetail: function(){
		return new Promise((success,fail)=>{
			if(store.getters.getAgent.code != ''){
				get("AFFILIATE",`affiliate/${store.getters.getAgent.code}`).then(response=>{
					let res = response.data
					if(res.success){
						store.commit("setAgent",[{key:'data',value:res.data}])
						success()
					}else{
						fail(res.message)
					}
				})
			}else{
				fail('code is empty')
			}
		})
	},
	$isNull: function(data){
		return !(data == null || data == '') ? true : false
	},
	$hasGoogleTag: function(){
		const { google_tag_manager_id = null, google_analytics_id = null } = store.getters.getMerchant;
		const { googleTagIds } = classifyTagIds([google_tag_manager_id, google_analytics_id]);
		return googleTagIds.length > 0 && typeof Vue.prototype.$gtag === 'function';
	},
	$isNotEmpty: function(data){
		return !(data == null || data == '') ? true : false
	},
	$isNotEmptyV2: function(data){
		if (data === null || data === undefined) {
			return false;
		}

		if (typeof data === 'string' && data.trim() === '') {
			return false;
		}

		if (Array.isArray(data) && data.length === 0) {
			return false;
		}

		if (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) {
			return false;
		}

		return true;
	},
  $isNotEmptyV3: function(data){
		if (data === null || data === undefined) {
			return false;
		}

    if (typeof data === 'number' && data === 0) {
			return false;
		}

		if (typeof data === 'string' && data.trim() === '') {
			return false;
		}

		if (Array.isArray(data) && data.length === 0) {
			return false;
		}

		if (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) {
			return false;
		}

		return true;
	},
	$compressImageOld: function(file){
		return new Promise((resolve)=>{
			new Compressor(file,{
				convertTypes: ['image/jpg'],
				convertSize: 5000000,
				success(result){
					resolve(result)
				},
				error(err) {
					resolve(err)
				},
			})
		})
	},
	$compressImage: function(file){
		return new Promise((resolve)=>{
			var imageFile = file;

			var options = {
				maxSizeMB: 1,
				maxWidthOrHeight: 1920,
				useWebWorker: true
			}
			imageCompression(imageFile, options)
				.then(function (compressedFile) {
					resolve(compressedFile)
				})
				.catch(function (error) {
					resolve(error.message);
				});
		})
	},
	$isNumberOnly: function(data){
		let regex = /^[0-9]+$/
		return regex.test(data)
	},
	$devConsole(msg,obj='not-used'){
		if(config.ENV == 'dev'){
			if(typeof(obj) == 'string' && obj == 'not-used'){
				console.log(msg)
			}else{
				console.log(msg,obj)
			}
		}
	},
	$isJokulCreditCard: function(bank_name,payment_method){
		return bank_name == 'JOKUL_DOKU' && payment_method == 'CREDIT_CARD'
	},
	$loadJokulScript: function(){
		return new Promise(done=>{
			if(window.loadJokulCheckout){
				done()
				return
			}

			let externalScript = document.getElementById(JOKUL_SCRIPT_ID)
			if(externalScript && externalScript.getAttribute('data-loaded') == 'true'){
				done()
				return
			}
			if(!externalScript){
				externalScript = document.createElement('script')
				externalScript.setAttribute('src', config.JOKUL_URL)
				externalScript.setAttribute('id', JOKUL_SCRIPT_ID)
				document.head.appendChild(externalScript)
			}
			externalScript.addEventListener('load',()=>{
				externalScript.setAttribute('data-loaded','true')
				done()
			})
			externalScript.addEventListener('error',()=>done())
		})
	},
	$openJokulCheckout: function(url){
		if(!url) return Promise.resolve(false)
		return Vue.prototype.$loadJokulScript().then(()=>{
			if(!window.loadJokulCheckout) return false
			window.loadJokulCheckout(url)
			return true
		})
	},
	$proceedPayment: function(module,inquiry,payment_result,selected_payment,sub_module){
		let selected_pg = selected_payment.bank_name
		let pg_mode = selected_payment.pg_mode
		var clearCart = () => {}
		var redirectPage = () => {}

		if(module == 'CONCIERGE'){
			clearCart = () => {
				store.commit("resetConciergeOrder")
				store.commit("resetAllDataConcierge")
			}
			redirectPage = () => {
				if(sub_module == 'CUSTOM_POS'){
					router.push({
						name: 'PosPaymentResult',
						params:{
							tx_order_id: inquiry.id,
							pos_code: payment_result.general_data.code
						}
					})
				}else{
					router.push({
						name: 'BeModuleServiceTrxResult',
						params:{
							trx_id: inquiry.id
						}
					})
				}
			}
		}else if(module == 'CONCIERGE_RESERVATION'){

			clearCart = () => {
				console.log("Nothing to clear")
			}
			redirectPage = () => {
				let params = {
					name: 'PaymentBillResultHotel',
					params:{
						merchant_code: store.getters.getMerchant.code,
						ga_reservation_id: payment_result.payment.reservation.id,
						tx_payment_id: payment_result.tx_order_id
					}
				}
				console.log("params : ", params)
				router.push(params)
			}
		}else if(module == 'UPSELLING'){
			clearCart = () => {
				store.commit("resetVoucherOrder")
			}
			redirectPage = () => {
				router.push({
					name: 'GroupVoucherBookingResult',
					params:{
						tx_order_id: inquiry.id
					}
				})
			}
		}else if(module == 'RESTAURANT'){
			clearCart = () => {
				store.commit("resetAllDataRestaurant")
			}
			redirectPage = () => {
				if(sub_module == 'GENERAL'){
					router.push({
						name: 'RestaurantTrxResult',
						params:{
							trx_id: inquiry.id
						}
					})
				}else{
					router.push({
						name: 'RestaurantPaymentResult',
						params:{
							tx_payment_id: payment_result.tx_order_id
						}
					})
				}
			}
		}else if(module == 'BE_ADDITIONAL_SERVICE'){
			clearCart = () => {
				store.commit("resetAllDataConcierge");
				store.commit("resetAllDataMarketing");
			}
			redirectPage = () => {
        router.push({
          name: 'BePaymentResult',
          params:{
            tx_order_id: inquiry.id
          },
          query:{
            module: "additional-service"
          }
        })
			}
		}

		if(Vue.prototype.$isPivotPayment(selected_pg)){
			clearCart()
			Vue.prototype.$openLink(Vue.prototype.$getPivotPaymentUrl(payment_result.payment))
		}else if(selected_pg == 'MIDTRANS'){
			clearCart()
			let scriptTag = document.createElement('script');
			scriptTag.src = config.MIDTRANS_URL
			scriptTag.setAttribute('data-client-key', payment_result.payment.client_key);
			document.head.appendChild(scriptTag);
			scriptTag.onload = function(){
				window.snap.pay(payment_result.payment.token)
			}
		}else if(selected_pg == 'IPAYMU' && pg_mode == 'CREDIT_CARD'){
			clearCart()
			Vue.prototype.$openLink(payment_result.payment.url)
		}else{
			clearCart()
			redirectPage()
		}
	},
	$convertObjectToStringParams: function(params){
		const esc = encodeURIComponent
		return (
			Object
			.keys(params)
			.map(k => esc(k) + '=' + esc(params[k]))
			.join('&')
		)
	},
	$is_merchant_community: function(){
		let community_id = store.getters.getMerchant.community.id ? store.getters.getMerchant.community.id : store.getters.getMerchant.community
		// return this.$app_env == 'dev' || (this.$app_env == 'prod' && config.COMMUNITY_SYSTEM != community_id) ? true : false
		return Vue.prototype.$app_env == 'prod' && config.COMMUNITY_SYSTEM != community_id
	},
	$textSplitter: function(data,splitter=2,connector="-"){
		let return_data = ""
		for(let i = 0; i <= data.length; i+=splitter){
			return_data += data.substring(i,i+splitter)
			if(i+splitter < data.length){
				return_data += connector
			}
		}
		return return_data
	},
	$getRandomNumber: function(min,max,type='int'){
		if(type == 'int'){
			min = Math.ceil(min);
			max = Math.floor(max);
			return Math.floor(Math.random() * (max - min) + min);
		}else{
			let data = Math.random() * (max - min) + min
			return data.toFixed(2)
		}
	},
	$validateActiveReward: function(page_module){
		let is_reward_active = store.getters.isMembershipRewardApplied
		let reward = store.getters.getMembershipRewardApplied
		if(is_reward_active){
			if(reward.type != page_module){
				let is_page_in_module = reward.module.some(x=>x.code == page_module)
				if(!is_page_in_module){
					store.commit("setMembershipRewardApplied",{})
				}
			}
		}

	},
	$isImageNull: function(image_url){
		let img_file_name = image_url.slice(-11)
		if(img_file_name == 'noimage.png') return true
		return false
	},
	$getAvlb: function(data,module='TICKET'){
		let avlb = 0
		if(module == 'TICKET'){
			if(data.use_master_availability){
				let all_avb_ref = []
				for (let i = 0; i < data.master_availability_reference.length; i++) {
					const el = data.master_availability_reference[i];
					let avb_ref_i = store.getters.getTicketAvb.findIndex(x=>x.id == el.reference_id)
					if(avb_ref_i != -1){
						let qty_temp = Math.floor(store.getters.getTicketAvb[avb_ref_i].availability/el.qty)
						all_avb_ref.push(qty_temp)
					}else{
						avlb = 0
						break;
					}
				}
				all_avb_ref = all_avb_ref.sort((a,b)=>a-b)
				avlb = all_avb_ref[0]
			}else{
				let record_variant = store.getters.getTicketAvb.findIndex(x=>x.id == data.id)
				if(record_variant != -1){
					avlb = store.getters.getTicketAvb[record_variant].availability
				}
			}
		}
		return avlb
	},
	$app_url: function(){
		const base_url = window.location.origin
		let url_list = [
			{
				url: 'https://secure.guestaps.com',
				code: 'PROD'
			},
			{
				url: 'https://guestapps.guestpro.co.id',
				code: 'DEV'
			},
			{
				url: 'https://guestapps-pub.guestpro.co.id',
				code: 'DEV-PUB'
			},
			{
				url: 'https://guestapps-lcl.guestpro.co.id',
				code: 'DEV-LCL'
			},
			{
				url: 'http://localhost:8080',
				code: 'LOCAL'
			},
		]
		let current_url = url_list.findIndex(x=>x.url == base_url)
		if(current_url != -1) return url_list[current_url]
		return url_list[4]
	},
	$isObjectEmpty(data){
		return Object.keys(data).length == 0
	},
	$deepCopy: function(data){
		return _.cloneDeep(data)
	},
	$showPDFFile: function(blob, file_name= "untitled.pdf", new_tab=false, download=false, is_base64=false){
		if(is_base64){
			const binaryData = atob(blob);

			// Create a Uint8Array from the binary data
			const uint8Array = new Uint8Array(binaryData.length);
			for (let i = 0; i < binaryData.length; i++) {
				uint8Array[i] = binaryData.charCodeAt(i);
			}
			blob = uint8Array
		}

		var newBlob = new Blob([blob], {type: "application/pdf"})
		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
				return;
		}
		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		var link = document.createElement('a');
		link.href = data;
		if (download) {
			link.download = file_name;
		}
		if (new_tab) {
			link.target = '_blank';
		}
		link.click();
		setTimeout(function(){
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(data);
		}, 100);

	},
	$domToImg: function(ref,file_name){
		return new Promise(async (resolve, reject) => {
			try {
				// Menggunakan html2canvas untuk mengonversi elemen menjadi gambar
				const canvas = await html2canvas(ref,{
					logging: false,
					useCORS: true
				});

				// Membuat URL gambar dari kanvas
				const imageDataURL = canvas.toDataURL('image/png');

				// Membuat elemen <a> untuk mengunduh gambar
				const downloadLink = document.createElement('a');
				downloadLink.href = imageDataURL;
				downloadLink.download = `${file_name}.png`;

				// Menambahkan elemen <a> ke DOM dan mengkliknya secara otomatis
				document.body.appendChild(downloadLink);
				downloadLink.click();

				// Membersihkan elemen <a> setelah pengunduhan
				document.body.removeChild(downloadLink);

				resolve('Image captured and downloaded successfully.');
			} catch (error) {
				reject('Error capturing or downloading image.');
			}
		});
	},
	$validatePage: function(type,data){
		return new Promise((success,fail)=>{
			const page_sub_module = this.$route.meta.sub_module ? this.$route.meta.sub_module : ''
			if(type == 'CONCIERGE'){
				const {pos_type} = data
				if(pos_type == 'ACTIVITY' && page_sub_module != 'hotel-activity'){
					router.push({
						name: 'HotelActivity',
						params:{
							merchant_code: store.getters.getMerchant.code,
							pos_code: data.code
						}
					})
					fail()
				}

				if(pos_type == 'SPA' && page_sub_module != 'concierge-spa'){
					router.push({
						name: 'ConciergeSpa',
						params:{
							merchant_code: store.getters.getMerchant.code
						}
					})
					fail()
				}

				if(pos_type == 'RESTAURANT' && page_sub_module != 'hotel-outlet'){
					router.push({
						name: 'PosHome',
						params:{
							merchant_code: store.getters.getMerchant.code,
							pos_code: data.code
						}
					})
					fail()
				}

				success()
			}
		})
	},
	$clearCartAdditionalService: function(){
		store.commit("clearTrxActivityProduct")
		store.commit("clearTrxOutletProduct")
		store.commit("resetAllDataMarketing")
	},
	$totalAddtServiceModule: function(){
		let total = store.getters.getActivityTrxDisplayTotal+store.getters.getOutletTrxTotal+store.getters.getVoucherOrderTotal
		return total
	},
	$convertCurrency: function(to,auto_set_base_rate=true){
		return fetchCurrencyRate(to).then(rate => {
			if(auto_set_base_rate) store.commit('setBaseRate', rate)
			return rate
		})
	},
	$isEmpty: (data) => {
		if (data === null || data === undefined) {
			return true;
		}

		if (typeof data === 'string' && data.trim() === '') {
			return true;
		}

		if (Array.isArray(data) && data.length === 0) {
			return true;
		}

		if (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) {
			return true;
		}

		return false;
	},
	$countDays: (startDate=null,endDate=null,formatStartFrom=null,formatEndFrom=null) => {
		if (startDate == null || endDate == null) return 0
		else{
			const fullStartDate = formatStartFrom == null ? moment(startDate) : moment(startDate, formatStartFrom)
			const fullEndDate = formatEndFrom == null ? moment(endDate) : moment(endDate, formatEndFrom)
			return fullEndDate.diff(fullStartDate, 'days')
		}
	},
	$getSelectedPotentialPromotion: (filterDate, isNeedValidateDate = false) => {
		const { startDate: checkinDate, endDate: checkoutDate } = filterDate;

		const updateFilterDate = (newCheckinDate) => {
      const currentTotalNight = Vue.prototype.$countDays(checkinDate,checkoutDate)

      const newStayDate = [{key: 'date', value: {
        check_in: newCheckinDate.clone().utc().toDate(),
        check_out: newCheckinDate.clone().add(currentTotalNight, 'd').utc().toDate()
      }}]
			store.commit('setSpecificBeFilter', newStayDate);
    }

		const validateCutOff = (promotion) => {
			const { promotion_type, formula, cut_off } = promotion;
      const { check_in_time_start, timezone } = store.getters.getMerchant;

      const validateApproaching = () => {
        const cutOffHours = formula.cut_off;
        const checkInTime = moment.tz(check_in_time_start, "HH:mm:ss", timezone);
        const promoStartTime = checkInTime.clone().subtract(cutOffHours, 'hours');

        const setFilterDateTime = (newDate, isToday) => {
          return isToday
          ? moment.tz(newDate, timezone).set({
              hour: moment().hour(),
              minute: moment().minute()
            })
          : moment.tz(filterDate, timezone).startOf('day');
        }

        const isFilterDateToday = moment(checkinDate).isSame(moment(), 'day');
        let filterDateTime = setFilterDateTime(checkinDate, isFilterDateToday);

        const isFilterDateValid = filterDateTime.isBetween(promoStartTime, checkInTime, null, '[)')
        if(isFilterDateValid) return false

        const isPromoStartToday = moment(promoStartTime).isSame(moment(), 'day');
        filterDateTime = setFilterDateTime(promoStartTime, isPromoStartToday);
        updateFilterDate(filterDateTime)
        return true;
      }

      const validateDistant = () => {
        const cutOffDays = promotion_type === 'MULTI_NIGHT' ? cut_off : formula.cut_off;
        const currentDate = moment.tz(timezone).startOf('day');
        const promoStartDate = currentDate.clone().add(cutOffDays, 'days');

        const filterDateTime = moment.tz(checkinDate, timezone).startOf('day');

        const isFilterDateValid = filterDateTime.isAfter(promoStartDate)
        if(isFilterDateValid) return false;

        filterDateTime.set({
          year: promoStartDate.year(),
          month: promoStartDate.month(),
          date: promoStartDate.date()
        });
        updateFilterDate(filterDateTime)
        return true
      }

      const isApproachingType = promotion_type === 'LAST_MINUTE_DEAL'
      const isDistantType = promotion_type === 'EARLY_BIRD' || promotion_type === 'MULTI_NIGHT'

      if(isApproachingType) return validateApproaching();
      else if(isDistantType) return validateDistant()

      return false;
		}

		const validateMinNight = (minNight) => {
      const currentTotalNight = Vue.prototype.$countDays(checkinDate,checkoutDate)
      if(currentTotalNight >= minNight) return false;

      const newStayDate = [{key: 'date', value: {
        check_in: checkinDate,
        check_out: moment(checkinDate).add(minNight, 'd').toDate()
      }}]
			store.commit('setSpecificBeFilter', newStayDate);
      return true;
		}

		const resetPromoCodeFilter = () => {
			const params = [{key: 'promo_code', value: ''}]
			store.commit('setSpecificBeFilter', params)
		}

		const validatePromotion = () => {
			const selectedPromotion = store.getters.getSelectedPromotion;
			if(Vue.prototype.$isEmpty(selectedPromotion)) return null;

			const { vuex_expired_at, min_night, promotion_type } = selectedPromotion;

			const isExpired = moment().utc().isAfter(vuex_expired_at);
			if(isExpired){
				store.commit('resetSelectedPromotion');
				return null;
			}

			if(promotion_type !== 'PROMO_CODE') resetPromoCodeFilter();
      if(isNeedValidateDate){
        validateMinNight(min_night);
        validateCutOff(selectedPromotion);
      }

			return selectedPromotion;
		}

		return validatePromotion();
	},
	$removeWhiteSpace: (text) => {
		return text.replace(/\s+/g, "");
	},
  $parsingRestaurantStatusText: (status) => {
    switch (status) {
      case 'PENDING':
        return 'Awaiting Confirmation';
      case 'ONPROGRESS':
        return 'Preparing Order';
      case 'ONDELIVERY':
        return 'On the Way';
      case 'WAITING_PAYMENT':
        return 'Awaiting Payment';
      case 'COMPLETE':
        return 'Order Complete';
      case 'CANCELLED':
        return 'Order Cancelled';
      default:
        return status;
    }
  },
  $generateOpenCloseProductTime: (openOrderTime = null, closeOrderTime = null, productName = null) => {
    const nowTime = moment();
    const returnData = {
      open: openOrderTime == null, // Default to true if no open time
      close: closeOrderTime == null, // Default to true if no close time
      openTime: "",
      closeTime: "",
      available: true,
      message: ""
    };

    const processTime = (time, type) => {
      if (time) {
        const timeWithTZ = moment(`${time}${store.getters.getMerchantTimezone.offset}`, "HH:mm:ssZ").toDate();
        const localTime = moment.parseZone(timeWithTZ).local();
        returnData[`${type}Time`] = localTime.format("h:mm A");
        returnData[type] = type === "open" ? localTime.isBefore(nowTime) : localTime.isAfter(nowTime);
      }
    };

    processTime(openOrderTime, "open");
    processTime(closeOrderTime, "close");

    // Adjust availability logic
    const openTimeMoment = moment(openOrderTime, "HH:mm:ss");
    const closeTimeMoment = moment(closeOrderTime, "HH:mm:ss");

    if (openOrderTime && closeOrderTime) {
      if (closeTimeMoment.isBefore(openTimeMoment)) {
        // If close time is before open time, assume closing happens on the next day
        returnData.close = moment().isBefore(closeTimeMoment) || moment().isAfter(openTimeMoment);
      }

      returnData.available = returnData.open && returnData.close;

      if (!returnData.available) {
        returnData.message = `Sorry, ${productName} is only available from ${returnData.openTime} to ${returnData.closeTime}`;
      }
    }

    return returnData;
  },
  $parsingDeliveryStatus: (status, currentNote) => {
    const statusList = [
      {
        "status": "confirmed",
        "description": "Order confirmed. Finding nearby partner to pick up your food."
      },
      {
        "status": "allocated",
        "description": "Delivery partner assigned. Heading to restaurant for pick-up."
      },
      {
        "status": "picking_up",
        "description": "Partner en route to restaurant for food pick-up."
      },
      {
        "status": "picked",
        "description": "Food collected from restaurant. Ready for delivery."
      },
      {
        "status": "dropping_off",
        "description": "Food on the way. Delivery in progress."
      },
      {
        "status": "return_in_transit",
        "description": "Order returning to restaurant due to delivery issue."
      },
      {
        "status": "on_hold",
        "description": "Delivery on hold. Awaiting resolution."
      },
      {
        "status": "delivered",
        "description": "Order delivered. Enjoy your meal!"
      },
      {
        "status": "rejected",
        "description": "Order rejected. Contact support for details."
      },
      {
        "status": "courier_not_found",
        "description": "No available partner. Order canceled."
      },
      {
        "status": "returned",
        "description": "Order returned to restaurant."
      },
      {
        "status": "cancelled",
        "description": "Order canceled per request."
      },
      {
        "status": "disposed",
        "description": "Order disposed after completion."
      }
    ]

    const selectedStatus = statusList.find(statusItem => statusItem.status === status);
    if(!selectedStatus) return currentNote;
    return selectedStatus.description;
  },
  $logO: (data, title="") => {
    console.log(`${title} : `, JSON.stringify(data));
  },
  $sendCustomTicketGTMDataLayer: (transactionDetail, eventName) => {
    const {
      tx_order_id,
      visit_date,
      customer_details: { first_name, last_name, email, phone_number, country },
      ticket_details,
      product_special,
      promotion,
      payment_details,
      status,
      transaction_date
    } = transactionDetail;

    const isDomestic = () => {
      if(!product_special) return false;

      const { strict_guest_profile_country = null } = product_special;
      return strict_guest_profile_country === 'Indonesia' ? true : false
    }

    const getProducts = () => {
      let products = [];
      ticket_details.forEach(product => {
        const {
          product_id,
          product_name,
          pax,
          price_sell,
          price_sell_discount,
          discount
        } = product;
        const selectedProductIndex = products.findIndex(prd => prd.product_id === product_id);

        if(selectedProductIndex === -1){
          const newProduct = {
            product_id,
            product_name,
            pax: pax.map(px => {
              const { id, name, qty } = px;
              return { id, name, qty }
            }),
            original_price: Number(price_sell),
            final_price: 	Number(price_sell_discount),
            discount: Number(discount),
          }
          products.push(newProduct);
        }else{
          let selectedProduct = products[selectedProductIndex];

          const paxMap = new Map(selectedProduct.pax.map(({ id, name, qty }) => [id, { id, name, qty }]));
          product.pax.forEach(({ id, name, qty }) => {
            if (paxMap.has(id)) paxMap.get(id).qty += qty;
            else paxMap.set(id, { id, name, qty });
          });
          products[selectedProductIndex].pax = Array.from(paxMap.values());

          products[selectedProductIndex].original_price += Number(price_sell),
          products[selectedProductIndex].final_price += 	Number(price_sell_discount),
          products[selectedProductIndex].discount += Number(discount)
        }
      });
      return products;
    }
    const bookedProduct = getProducts();

    let dataLayer = {
      event: eventName,
      transaction_id: tx_order_id,
      visit_date,
      guest_detail: {
        name: last_name ? `${first_name} ${last_name}` : first_name,
        phone: phone_number,
        email,
        country
      },
      tickets: {
        domestic: isDomestic() ? "yes" : "no",
        promo_code: promotion && promotion.promo_code ? promotion.promo_code : "",
        products: bookedProduct
      },
      currency: store.getters.getMerchant.base_currency_code,
      sub_total: bookedProduct.reduce((acc,value) => acc + value.original_price, 0),
      discount: bookedProduct.reduce((acc,value) => acc + value.discount, 0),
      transaction_amount: bookedProduct.reduce((acc,value) => acc + value.final_price, 0),
      transaction_method: payment_details ? payment_details.payment_method_name : "",
      transaction_status: status,
      transaction_time: moment.parseZone(transaction_date).format("YYYY-MM-DD HH:mm:ss")
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayer);
  },
  $calculateSubTotalPerRoom: (room) => {
    const { search_room_is_show_tax_fee_note: showTaxes } = store.getters.getMerchant;

    let total = 0;
    room.guest.forEach((guest) => {
      const { adult, child, infant } = guest.extra;
      let totalPerNight = 0;
      room.room_rate.dates.forEach((dates) => {
        const {
          adult: date_adult,
          child: date_child,
          infant: date_infant,
        } = dates.extra_guest;
        let total_extra = {
          adult: adult * date_adult.amount,
          child: child * date_child.amount,
          infant: infant * date_infant.amount,
        };
        let total_extra_price = total_extra.adult + total_extra.child + total_extra.infant;

        const originalPrice = dates.final_price - dates.extra_guest_price;
        totalPerNight += originalPrice + total_extra_price;
        if(showTaxes){
          totalPerNight += dates.taxes
        }
      });
      total += totalPerNight;
    });
    return total;
  },
  $sendHotelUserGuestDataLayer: (eventName, detailData) => {
    const { checkIn, checkOut, adult, child, infant } = detailData;

    const totalNights = () => {
      const formatDate = "YYYY-MM-DD";
      return moment(checkOut, formatDate).diff(moment(checkIn, formatDate), "days");
    }

    const baseParams = {
      checkIn, checkOut,
      currency: store.getters.getMerchant.base_currency_code,
      dateFormat: "yyyy-MM-dd",
      nights: totalNights(),
      adults: adult,
      children: child,
      infants: infant
    };


    let finalParams = { event: eventName };
    if(eventName === 'availability'){
      const { room, roomRate, bestPrice } = detailData;
      finalParams.availabilityData = {
        ...baseParams,
        room, roomRate, bestPrice
      }
    } else if(eventName === 'conversion'){
      const { totalPrice, detailTransaction, invoiceNumber	 } = detailData;

      const roomList = () => {
        let rooms = [];
        detailTransaction.forEach(room => {
          rooms.push({
            roomName: room.room_type.name,
            roomRateName: room.name,
            rateName: room.rate.name,
            qty: room.qty,
            price: room.dates.reduce((acc,value) => acc + value.sub_total, 0)
          })
        });
        return rooms;
      }

      finalParams.conversionData = {
        ...baseParams,
        invoiceNumber,
        price: totalPrice,
        rooms: roomList()
      }
    }

    if(!window.dataLayer || !Array.isArray(window.dataLayer)) window.dataLayer = [];
    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push(finalParams);
    }

    if(!window.ugLayer || !Array.isArray(window.ugLayer)) window.ugLayer = [];
    if(Array.isArray(window.ugLayer)){
      window.ugLayer.push(finalParams);
    }
  },
  $convertNewlinesToBr: (text) => {
    return text ? text.replace(/\n/g, '<br>') : '';
  },
  $normalizeError: (error) => {
    return error instanceof Error ? error : new Error(String(error));
  },
  $isProductAllowDelivery: (product) => {
    const { use_delivery, use_biteship } = store.getters.getMerchant;
    const { allow_delivery, mass } = product
    if(use_delivery && use_biteship){
      return allow_delivery && Vue.prototype.$isNotEmptyV2(mass) && mass > 0;
    }
    if(use_delivery){
      return allow_delivery
    }

    return false;
  },
  $isProductImageHidden: (moduleConfig) => {
    if (!moduleConfig) return false
    return moduleConfig.hide_product_image === true || moduleConfig.hide_product_image === 'true'
  },
  $getModuleConfig: (moduleKey) => {
    if (!Vue.prototype.$isNotEmptyV2(moduleKey)) return {}

    const moduleConfig = store.getters.getModuleConfig[moduleKey]
    return moduleConfig ? moduleConfig : {}
  },
  $getOrCreateSessionId: () => {
    let sessionId = sessionStorage.getItem('session_id');

    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substring(2, 8);
      sessionStorage.setItem('session_id', sessionId);
    }

    return sessionId;
  },
  $getFbpFbc: () => {
    // Get _fbp from cookie
    const fbpMatch = document.cookie.match(/_fbp=([^;]+)/);
    const fbp = fbpMatch ? fbpMatch[1] : null;

    // Get _fbc from cookie
    const fbcMatch = document.cookie.match(/_fbc=([^;]+)/);
    let fbc = fbcMatch ? fbcMatch[1] : null;

    // If _fbc cookie not found, try to get fbclid from URL
    if (!fbc) {
      const urlParams = new URLSearchParams(window.location.search);
      const fbclid = urlParams.get('fbclid');
      if (fbclid) {
        // Generate fbc format: fb.1.{timestamp}.{fbclid}
        const timestamp = Math.floor(Date.now() / 1000);
        fbc = `fb.1.${timestamp}.${fbclid}`;
      }
    }

    return {
      fbp: fbp || null,
      fbc: fbc || null
    };
  },
  $hashForMeta: async (value) => {
    if (!value || typeof value !== 'string' || value.trim() === '') {
      return null; // Jangan hash jika value kosong
    }

    // Bersihkan dan normalisasi string
    const normalized = value.trim().toLowerCase();

    // Encode ke UTF-8
    const encoder = new TextEncoder();
    const data = encoder.encode(normalized);

    // Hash dengan SHA256
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Convert hasil buffer ke hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
  },
  $sendEventMetaConversionsAPI: async (eventName, detailData, type = "") => {

    const {
      id: merchant_id,
      base_currency_code: currency,
      merchant_type,
      use_meta_pixel_id,
      use_meta_pixel_capi,
      meta_pixel_id
    } = store.getters.getMerchant;

    const isMerchantHotel = merchant_type === 'hotel';
    const isAuthValid = use_meta_pixel_id && Vue.prototype.$isNotEmptyV2(meta_pixel_id);

    if(!isMerchantHotel || !isAuthValid) return;


    const generateParams = async () => {
      const isNotEmpty = (value) => Vue.prototype.$isNotEmptyV2(value);
      const hashData = async (value) => {
        const hashResult = await Vue.prototype.$hashForMeta(value);
        return hashResult;
      }

      const eventWithSession = eventName === 'Search';
      const eventWithRoomId = eventName === 'ViewContent' || eventName === 'AddToWishlist';
      const eventWithTransactionIdList = ["InitiateCheckout", "AddPaymentInfo", "Purchase"]
      const eventWithTransactionId = eventWithTransactionIdList.some(evt => evt === eventName);

      const eventTime = Math.floor(Date.now() / 1000);
      const eventId = () => {
        let uniqueKey = null;

        if (eventWithSession){
          uniqueKey = Vue.prototype.$getOrCreateSessionId();
        } else if (eventWithRoomId) {
          uniqueKey = detailData.id;
        } else if (eventWithTransactionId) {
          uniqueKey = detailData.tx_order_id;
        }

        return `${eventName}_${eventTime}${uniqueKey? '_'+uniqueKey : ''}`
      }

      const { fbp, fbc } = Vue.prototype.$getFbpFbc();

      const { date: { check_in, check_out }, guest: { adult: num_adults, child: num_children, infant: num_infants } } = store.getters.getBeFilter;

      const getGeneralFilter = () => {
        const totalNights = () => moment(check_out).diff(moment(check_in), "days");

        return {
          checkin_date: Vue.prototype.$formatDateApi(check_in),
          checkout_date: Vue.prototype.$formatDateApi(check_out),
          total_nights: totalNights(),
          num_adults, num_children, num_infants
        }
      }

      let param = {
        merchant_id,
        api_version: "v23.0",
        data: [
          {
            event_name: eventName,
            event_time: eventTime,
            event_id: eventId(),
            action_source: "website",
            event_source_url: window.location.href,
            custom_data: {
              value: 0,
              currency
            }
          }
        ]
      }

      param.data[0].user_data = {}
      if(fbp || fbc){
        if (fbp) param.data[0].user_data.fbp = fbp;
        if (fbc) param.data[0].user_data.fbc = fbc;
      }

      const userLoggedIn = store.getters.getCurrentUser;
      const eventsWithOwnUserData = eventWithTransactionId || eventName === 'Lead'
      if(isNotEmpty(userLoggedIn) && !eventsWithOwnUserData){
        const {email, phone, first_name, last_name} = userLoggedIn

        let moreUserData = {}

        if(isNotEmpty(email)) moreUserData.em = await hashData(email);
        if(isNotEmpty(phone)) moreUserData.ph = await hashData(phone);
        if(isNotEmpty(first_name)) moreUserData.fn = await hashData(first_name);
        if(isNotEmpty(last_name)) moreUserData.ln = await hashData(last_name);

        param.data[0].user_data = {
          ...moreUserData,
          ...param.data[0].user_data,
        }
      }

      if(isNotEmpty(userLoggedIn)){
        param.data[0].user_data.external_id = userLoggedIn.id
      }else if(isNotEmpty(store.getters.getClientUid)){
        param.data[0].user_data.external_id = store.getters.getClientUid
      }else{
        const client_uid = Vue.prototype.$createUUID();
        store.commit("setClientUid",client_uid)
        param.data[0].user_data.external_id = client_uid
      }


      if(eventWithRoomId){
        const { id, name, room_rate = {} } = detailData;

        const item_price = eventName === 'ViewContent' && type === 'Room Type' ? 0 : detailData.dates.reduce((acc,value) => acc + value.final_price, 0)

        let roomDetail = {
          content_type: type === "Room Type" ? "product_group" : "product",
          content_ids: [id],
          contents: [],
          content_name: name,
        }
        if(eventName === 'ViewContent') roomDetail.content_category = type

        if(eventName === 'AddToWishlist' || type === 'Room Rate'){
          roomDetail.contents = [{
            id,
            quantity: eventName === 'AddToWishlist' ? detailData.qty : 1,
            item_price
          }]
          roomDetail.value = eventName === 'AddToWishlist' ? item_price * detailData.qty : item_price;
        }else{
          roomDetail.contents = room_rate.map(rr => {
            return {
              id: rr.id_ori,
              quantity: 1,
              item_price: rr.dates.reduce((acc,value) => acc + value.final_price, 0)
            }
          })
        }

        param.data[0].custom_data = { ...param.data[0].custom_data, ...roomDetail, ...getGeneralFilter()};
      }

      if(eventName === 'Search'){
        param.data[0].custom_data = {
          ...param.data[0].custom_data,
          ...getGeneralFilter()
        };
      }

      if(eventWithTransactionId){
        const {
          tx_order_id: transaction_id, transaction_details, additional_service_details, tx_merchant_pos,
          customer_details,
          payments: { total_payment },
          payment_method_selected = null,
        } = detailData;
        const { check_in_date: checkin_date, check_out_date: checkout_date } = transaction_details[0];

        const getDateFilter = () => {checkin_date, checkout_date}

        const getProducts = () => {
          let products = [];
          const assignProduct = (id, quantity, item_price, type) => {
            products.push({id, quantity, item_price, type})
          }

          transaction_details.forEach(({ room_rate_id: id, qty, dates }) => assignProduct(id, qty, dates.reduce((acc,value) => acc + value.sub_total, 0), "room"))

          additional_service_details.forEach(({ id, qty, price }) => assignProduct(id, qty, price*qty, "additional_product"));

          tx_merchant_pos.forEach(merchant_pos=>{
            merchant_pos.products.forEach(({ id, qty, subtotal_sell }) => assignProduct(id, qty, subtotal_sell, "additional_product"))
          })

          return products;
        }

        const allProducts = getProducts();

        const getTotalPax = (field) => {
          return transaction_details.reduce((acc,value) => acc + Number(value[field]), 0)
        }

        let transactionDetail = {
          content_type: "product",
          content_ids: allProducts.map(product => product.id),
          contents: allProducts,
          num_items: allProducts.reduce((acc,value) => acc + value.quantity, 0),
          currency,
          value: Number(total_payment),
          ...getDateFilter(),
          num_adults: getTotalPax('adult'),
          num_children: getTotalPax('child'),
          num_infants: getTotalPax('infant'),
        }

        if(eventName === 'AddPaymentInfo') transactionDetail.payment_method = payment_method_selected
        if(eventName === 'Purchase') transactionDetail.order_id = transaction_id

        const getUserData = async () => {
          const { email, phone_number, first_name, last_name, country } = customer_details;

          let moreUserData = {}

          if(isNotEmpty(email)) moreUserData.em = await hashData(email);
          if(isNotEmpty(phone_number)) moreUserData.ph = await hashData(phone_number);
          if(isNotEmpty(first_name)) moreUserData.fn = await hashData(first_name);
          if(isNotEmpty(last_name)) moreUserData.ln = await hashData(last_name);
          if(isNotEmpty(country)) moreUserData.country = await hashData(country);

          return moreUserData;
        }

        const moreUserData = await getUserData();
        param.data[0].user_data = {
          ...moreUserData,
          ...param.data[0].user_data,
        }

        param.data[0].custom_data = transactionDetail
      }

      if(eventName === 'Lead'){
        const { email, phone = null, first_name, last_name } = detailData;

        let moreUserData = {}

        if(isNotEmpty(email)) moreUserData.em = await hashData(email);
        if(isNotEmpty(phone)) moreUserData.ph = await hashData(phone);
        if(isNotEmpty(first_name)) moreUserData.fn = await hashData(first_name);
        if(isNotEmpty(last_name)) moreUserData.ln = await hashData(last_name);

        param.data[0].user_data = {
          ...moreUserData,
          ...param.data[0].user_data,
        }
        param.data[0].custom_data = {
          lead_type: 'account_registration',
          account_type: 'customer',
          source: 'website_form'
        }
      }

      if(eventName === 'Contact'){
         param.data[0].custom_data = {
         contact_method: detailData
        }
      }

      return param
    }

    try {
      const generalParams = await generateParams();

      if(use_meta_pixel_capi){
        const apiResponse = await post("CORE_HOTEL", "meta-pixel/event", generalParams);
        const { success, message } = apiResponse.data;
        if(!success) throw new Error(message);
      }

      if(window.fbqReady) fbq('track', eventName, generalParams.data[0].custom_data, { eventID: generalParams.data[0].event_id});

    } catch (error) {
      console.log("ERROR Meta Pixel or Conversions API : ", error.message);
    }


  },
  $showCommunity: () => {
    const merchant = store.getters.getMerchant;

    const isCommunityUseGroupBooking = typeof merchant.community === 'object' && merchant.community.use_group_booking;
    if(isCommunityUseGroupBooking) return false

    const communityId = merchant.community.id ? merchant.community.id : merchant.community
    const isCommunityDefault = config.COMMUNITY_SYSTEM == communityId
    const isAllowedDommunity = () => {
      const allowedCommunity = ['coinfestasia', 'baliblockchainsummit', 'ghr']
      return allowedCommunity.some(x=> x == merchant.community.code)
    }
    const isTestCommunity = () => merchant.community.code.substring(0, 11) == 'testing-gp-'

    // return this.$app_env == 'dev' || (this.$app_env == 'prod' && config.COMMUNITY_SYSTEM != communityId) ? true : false
    return this.$app_env == 'prod' && !isCommunityDefault && !isAllowedDommunity() && !isTestCommunity()
  },
  $validateUserMenu: () => {
    const { use_user_menu, code } = store.getters.getMerchant;
    if(!use_user_menu) router.push(`/${code}`)
  },
  $selectActiveMerchantPos: (posList, activeModule) => {
    let result = Vue.prototype.$deepCopy(posList);

    const getActiveHotelModule = store.getters.getActiveHotelModule;
    if(activeModule !== 'additional_service' || Vue.prototype.$isEmpty(getActiveHotelModule)) return result;

    const currentPosId = getActiveHotelModule.merchant_pos.id;
    const selectedPos = result.findIndex(pos => pos.id === currentPosId);

    if(selectedPos === -1) return result;

    result[selectedPos].is_active = true

    return result;
  },
  $getConciergeBasePrice: (price) => {
    const { tax_service_calculation_type, price_sell_base, service_amount, tax_amount } = price

    const isTaxIncluded = tax_service_calculation_type === 'INCLUDE';
    const baseWithTax = price.price_sell_base + service_amount + tax_amount;

    return isTaxIncluded ? price_sell_base : baseWithTax
  },
  $getConciergeDisplayPrice: (price) => {
    const { tax_service_calculation_type, price_sell_final, price_sell_final_with_tax_service } = price

    const isTaxExcluded = tax_service_calculation_type === 'EXCLUDE';

    return isTaxExcluded ? price_sell_final : price_sell_final_with_tax_service
  },
  $showRoomPriceDecoy: (dates) => {
    const { login_tier_adjustment = null, room_rate_tier_mode = "", login_auto_assign } = store.getters.getMerchant;
    const isUserLoggedIn = Vue.prototype.$isNotEmptyV2(store.getters.getCurrentUser);

    let totalBase = 0;
    let totalDecoy = 0;

    const isNotEmpty = (data) => Vue.prototype.$isNotEmptyV2(data)

    dates.forEach(date => {
      totalBase += (date.final_price);
      if(isNotEmpty(login_tier_adjustment) && isNotEmpty(date.tier) && isNotEmpty(date.tier[login_tier_adjustment])) {
        totalDecoy += (date.tier[login_tier_adjustment].final_price);
      }
    });

    return login_auto_assign
      && !isUserLoggedIn
      && room_rate_tier_mode === 'BASIC_WITH_FORMULA'
      && Vue.prototype.$isNotEmptyV2(login_tier_adjustment)
      && totalDecoy < totalBase
      && totalDecoy > 0;
  },
  $showDiscountMembership: (dates) => {
    const isUserLoggedIn = Vue.prototype.$isNotEmptyV2(store.getters.getCurrentUser);

    let totalBase = 0;
    let totalDecoy = 0;
    dates.forEach(date => {
      const { tier, tier_active_before_adjust_index: baseIndex, tier_active_index } = date;
      if(Vue.prototype.$isNotEmptyV2(tier)){
        totalBase += (tier[baseIndex].final_price);
        totalDecoy += (tier[tier_active_index].final_price);
      }
    });

    return isUserLoggedIn && totalBase > totalDecoy;
  },
  $getCommunityOrigin: () => {
    const {
      group_booking_is_white_label: isCustomDomain,
      group_booking_domain_url: domainUrl,
      code
    } = store.getters.getMerchant.community;

    return isCustomDomain ? domainUrl :`${config.COMMUNITY_APP_URL}/${code}`
  },
  $getCommunityUrl: (path) => appendVisitorParam(`${Vue.prototype.$getCommunityOrigin()}${path}`),
  $useCommunityAuth: () => {
    const { community} = store.getters.getMerchant;
    if(Vue.prototype.$isEmpty(community)) return false;

    const { use_group_booking_auth = false } = community;

    return use_group_booking_auth;
  },
  $printRoomMemberPrice: (dates) => {
    const { login_tier_adjustment = null } = store.getters.getMerchant;
    return dates.reduce((sum, value) => {
      return sum + (value.tier && value.tier[login_tier_adjustment] ? value.tier[login_tier_adjustment].final_price : 0)
    },0)
  },
  $loginWithCommunity: () => {
    return new Promise((resolve, reject) => {
      const COMMUNITY_ORIGIN = Vue.prototype.$getCommunityOrigin();
      let onCommunityMsgBound = null;
      let loginTimeoutId = null;
      let popupWatchId = null;
      let authPopup = null;

      const cleanUpData = () => {
        if (onCommunityMsgBound) {
          window.removeEventListener('message', onCommunityMsgBound)
          onCommunityMsgBound = null
        }
        if (popupWatchId) {
          clearInterval(popupWatchId)
          popupWatchId = null
        }
        if (loginTimeoutId) {
          clearTimeout(loginTimeoutId)
          loginTimeoutId = null
        }
        if (authPopup && !authPopup.closed) {
          authPopup.close()
        }
      }

      try {
        const CURRENT_ORIGIN = window.location.origin;
        const url = buildCommunityLoginUrl(CURRENT_ORIGIN, COMMUNITY_ORIGIN);

        authPopup = window.open(url, 'auth', 'width=480,height=650')
        if (!authPopup) {
          reject(new Error('Popup blocked'));
        }

        onCommunityMsgBound = (event) => onMessageFromCommunityAuth(event, COMMUNITY_ORIGIN, authPopup)
        window.addEventListener('message', onCommunityMsgBound)

        loginTimeoutId = setTimeout(() => {
          cleanUpData();
          reject(new Error('Login timeout'));
        }, 60000);

        popupWatchId = setInterval(() => {
          if (!authPopup || authPopup.closed) {
            cleanUpData();
            reject(new Error('Popup closed by user'));
          }
        }, 500);

        // resolve()
      } catch (error) {
        cleanUpData()
        reject(error);
      }
    });
  },
  $generateRewardIdRoomPromotion: () => {
    const promotion = store.getters.getSelectedPromotion
    if(Vue.prototype.$isEmpty(promotion) || promotion.promotion_type !== 'MEMBERSHIP') return '';
    return promotion.membership_reward.reward.id
  },
  $generateFullName: (title,firstName,lastName) => {
    const titleParsed = Vue.prototype.$isNotEmpty(title) ? `${Vue.prototype.$capitalize(title)}. ` : ""
    const lastNameParsed = Vue.prototype.$isNotEmpty(lastName) ? lastName : ""
    return `${titleParsed}${firstName} ${lastNameParsed}`
  },
  $greenTaxes: () => {
    const isEmpty = (data) => Vue.prototype.$isEmpty(data);

    const {
      getMerchant: {
        country = "",
        booking_engine_tax_adult_per_night: adultTax,
        booking_engine_tax_child_per_night: childTax,
        booking_engine_tax_infant_per_night: infantTax,
       },
      getBeCart: { room_rate_details = [] },
      getBeFilter: { date : { check_in, check_out } }
    } = store.getters

    if(country !== "Maldives" || isEmpty(room_rate_details)) return { deposit: 0, pay_later: 0};

    const totalNight = Vue.prototype.$countDays(check_in, check_out);
    const calTotalGuest = (type, guests) => Number(guests.included[type]) + Number(guests.extra[type])

    const taxPax = { adult: adultTax, child: childTax, infant: infantTax, }
    const calTotalTaxPerPax = (type, paxQty, roomRate) => {
      if(taxPax[type] <= 0) return { deposit: 0, pay_later: 0 };

      let deposit = 0
      const totalTaxes = (paxQty * totalNight) * taxPax[type]

      const { minimum_deposit_type: depositType, minimum_deposit_value: depositValue } = roomRate;
      const isDepositByNight = depositType === 'NIGHT';
      if(isDepositByNight){
        const totalNightByDeposit = totalNight < depositValue ? totalNight : depositValue
        deposit = (paxQty * totalNightByDeposit) * taxPax[type]
      }else{
        deposit = (totalTaxes * depositValue) / 100
      }

      return {
        deposit: deposit,
        pay_later: totalTaxes - deposit
      }
    }
    const GUEST_TYPE = ['adult', 'child', 'infant'];

    let totalDeposit = 0;
    let totalPayLater = 0;
    room_rate_details.forEach(room => {
      room.guest.forEach(guest => {
        GUEST_TYPE.forEach(guestType => {
          const totalGuestQty = calTotalGuest(guestType, guest)
          if(totalGuestQty > 0){
            const { deposit, pay_later } = calTotalTaxPerPax(guestType, totalGuestQty, room.room_rate)
            totalDeposit += deposit
            totalPayLater += pay_later
          }
        })
      })
    })

    return {
      deposit: totalDeposit,
      pay_later: totalPayLater
    };
  },
  $calculatePriceByPax: (guestInclued, roomDate, defaultGuestIncluded) => {
    const generatePrice = (priceData) => {
      const { price, promotion_price } = priceData;
      return { price, promotion: promotion_price }
    }

    const useReducePriceByPax = Vue.prototype.$isNotEmptyV2(roomDate.price_per_guest);
    if(!useReducePriceByPax) return generatePrice(roomDate);

    const isCurrentSameWithDefault = guestInclued === defaultGuestIncluded;
    const normalPrice = roomDate.normal_price.price

    if(isCurrentSameWithDefault) return generatePrice(roomDate.normal_price);

    const selectedPaxPrice = roomDate.price_per_guest.find(priceGuest => priceGuest.total_guest === guestInclued && priceGuest.is_active)
    if(Vue.prototype.$isEmpty(selectedPaxPrice)) return generatePrice(roomDate.normal_price);

    const { reduce_by_pax_amount, promotion_price } = selectedPaxPrice;
    const price = normalPrice - reduce_by_pax_amount;
    return generatePrice({price, promotion_price});
  },
  $showHotelMembershipPoint: () => {
    const merchant = store.getters.getMerchant;

    if(!merchant || !merchant.community || typeof merchant.community != "object") return { trx: false, xp: true};

    const {
      show_membership_point: trx,
      show_membership_xp_point: xp
    } = merchant.community.use_community_membership ? merchant.community : merchant;

    return {trx, xp}
  },
  $printTotalGuestPerRoom: (savedRoom) => {
    const { guest, room_rate: { room_type: { type } }, qty } = savedRoom

    const totalGuest = guest.reduce(
      (acc, cur) =>
        acc +
        Object.keys(cur.included).reduce(
          (sum, key) => sum + cur.included[key] + cur.extra[key],
          0
        ),
      0
    );

    const typeLower = type.toLowerCase();
    const propertyType = qty > 1 ? `, ${qty} ${typeLower}` : `/ per ${typeLower}`

    return `${totalGuest} guest ${propertyType}`;
  },
  $sumByKeys: (...sources) =>{
    return sources.reduce((acc, obj) => {
      for (const [k, v] of Object.entries(obj || {})) {
        acc[k] = (acc[k] ? acc[k] : 0) + (typeof v === 'number' ? v : 0);
      }
      return acc;
    }, {})
  },
  $isPaymentManual: (payment) => {
    const { bank_name, payment_method } = payment;
    const isManualPG = bank_name === 'DIRECT_PAYMENT' || bank_name === 'WISE';
    const isBankTransfer = payment_method === 'BANK_TRANSFER';

    return isManualPG && isBankTransfer;
  },
  $isPivotPayment: (bankName) => bankName === 'PIVOT',
  // Pivot URL sits flat on payment_details but nested under .payment in the raw PG response
  $getPivotPaymentUrl: (source) => {
    if (!source) return '';
    if (typeof source === 'string') {
      try {
        return Vue.prototype.$getPivotPaymentUrl(JSON.parse(source));
      } catch (error) {
        return '';
      }
    }
    if (source.pivot_payment_url) return source.pivot_payment_url;
    return (source.payment && source.payment.pivot_payment_url) || '';
  },
  $submitPaymentFlywire: async (paymentResult, isReload = false, module = 'BOOKING_ENGINE') => {
    return new Promise((resolve, reject) => {
      const { ENV, BASE_API, BASE_API_DEMO = "", FLYWIRE_URL } = config
      const {
        amount, recipient_code: recipientCode, reference_id, tx_sk = "",
        customer_details: {
          first_name: firstName, last_name: lastName, phone_number: phone, email
        },
        tx_order_id = "", reservation_id = ""
      } = paymentResult;

      let scriptTag = document.createElement('script');
      scriptTag.src = FLYWIRE_URL;
      document.head.appendChild(scriptTag);

      scriptTag.onload = function () {
        const staticConfig = {
          env: ENV === 'dev' ? "demo" : "prod",
          provider: 'guestpro-int',
          paymentOptionsConfig: {
            filters: {type: ['credit_card'], currency: ['local']}
          },
          requestPayerInfo: true,
          callbackVersion: "2",
          provider: "guestpro-int"
        }

        const dynamicConfig = {
          recipientCode, amount, firstName, lastName, email,  phone,
          nonce: reference_id,
          recipientFields: { booking_reference: reference_id },
          callbackId: reference_id,
          callbackUrl: `${ENV === 'dev' ? BASE_API_DEMO : BASE_API}flywire/notify`
        }

        const getRedirectConfig = (status = null) => {
          const configs = {
            'BOOKING_ENGINE': {
              name: 'BePaymentResult',
              params: { tx_order_id },
              query: { tx_sk, ...(status && { statusGateaway: status }) },
              cancel: { module: 'CORE_HOTEL', url: `tx-detail/${tx_order_id}/cancel-payment` }
            },
            'RESERVATION_BILL': {
              name: 'PaymentBillResultHotel',
              params: {
                ga_reservation_id: reservation_id,
                tx_payment_id: tx_order_id
              },
              query: { tx_sk }
            },
            'TICKET': {
              name: 'TicketPaymentResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE', url: `tx-ticket-detail/${tx_order_id}/cancel-transaction` }
            },
            'POS': {
              name: 'PosPaymentResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'ACTIVITY': {
              name: 'BeModuleServiceTrxResult',
              params: { trx_id: tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'VOUCHER': {
              name: 'GroupVoucherBookingResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'RESTAURANT': {
              name: 'RestaurantTrxResult',
              params: { trx_id: tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_RESTO', url: `v2/tx-history/${tx_order_id}/cancel-transaction` }
            },
          };
          return configs[module] || configs['BOOKING_ENGINE'];
        }

        const handleRedirect = (status = null) => {
          if(module === 'POS') store.commit('clearTrxOutletProduct');
          if(module === 'VOUCHER') store.commit('resetVoucherOrder');
          if(module === 'ACTIVITY') store.commit('clearTrxActivityProduct');
          if (isReload) {
            window.location.reload();
            return;
          }

          const { name, params, query = {} } = getRedirectConfig(status);
          router.push({ name, params, query });
          resolve();
        };

        let flywireConfig = {
          ...staticConfig,
          ...dynamicConfig,
          onCompleteCallback: function(args) {
            const { status = "success" } = args;
            handleRedirect(status);
          },
          onCancel: (arg) => {
            if(module === 'RESERVATION_BILL') {
              handleRedirect();
              return;
            }

            const { cancel: { module: api_module, url: api_url } } = getRedirectConfig();
            post(api_module, `${api_url}?merchant_id=${store.getters.getMerchant.id}`).then(() => {
              handleRedirect();
            });
          }
        };

        var modal = FlywirePayment.initiate(flywireConfig);
        modal.render();
      };
    });

  },
  $submitPaymentRazorpay: async (paymentResult, isReload = false, module = 'BOOKING_ENGINE') => {
    return new Promise((resolve, reject) => {
      const { RAZORPAY_URL, BASE_API } = config
      const {
        amount, razorpay_key_id, razorpay_order_id, reference_id,
        tx_sk = "", tx_order_id = "", invoice_no = "", reservation_id = "",
        customer_details: {
          first_name, last_name, phone_number, email
        },
        payment_config:{
          channel, code = ""
        }
      } = paymentResult;

      let scriptTag = document.createElement('script');
      scriptTag.src = RAZORPAY_URL;
      document.head.appendChild(scriptTag);

      scriptTag.onload = function () {
        const getRedirectConfig = (status = null) => {
          const configs = {
            'BOOKING_ENGINE': {
              name: 'BePaymentResult',
              params: { tx_order_id },
              query: { tx_sk, ...(status && { statusGateaway: status }) },
              cancel: { module: 'CORE_HOTEL', url: `tx-detail/${tx_order_id}/cancel-payment` }
            },
            'RESERVATION_BILL': {
              name: 'PaymentBillResultHotel',
              params: {
                ga_reservation_id: reservation_id,
                tx_payment_id: tx_order_id
              },
              query: { tx_sk },
            },
            'TICKET': {
              name: 'TicketPaymentResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE', url: `tx-ticket-detail/${tx_order_id}/cancel-transaction` }
            },
            'POS': {
              name: 'PosPaymentResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'ACTIVITY': {
              name: 'BeModuleServiceTrxResult',
              params: { trx_id: tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'VOUCHER': {
              name: 'GroupVoucherBookingResult',
              params: { tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_HOTEL', url: `merchant-pos/transaction/${tx_order_id}/cancel-transaction` }
            },
            'RESTAURANT': {
              name: 'RestaurantTrxResult',
              params: { trx_id: tx_order_id },
              query: { tx_sk },
              cancel: { module: 'CORE_RESTO', url: `v2/tx-history/${tx_order_id}/cancel-transaction` }
            },
          };
          return configs[module] || configs['BOOKING_ENGINE'];
        }

        const handleRedirect = (status = null) => {
          if(module === 'POS') store.commit('clearTrxOutletProduct');
          if(module === 'VOUCHER') store.commit('resetVoucherOrder');
          if(module === 'ACTIVITY') store.commit('clearTrxActivityProduct');
          if (isReload) {
            window.location.reload();
            return;
          }

          const { name, params, query = {} } = getRedirectConfig(status);
          router.push({ name, params, query });
          resolve();
        };

        const buildCheckoutConfig = () => {
          if (channel === 'CREDIT_CARD') {
            return {
              display: {
                hide: [
                  { method: 'fpx' },
                  { method: 'wallet' },
                  { method: 'netbanking' },
                  { method: 'paylater' },
                  { method: 'upi' }
                ],
                preferences: {
                  show_default_blocks: true
                }
              }
            };
          } else if (channel === 'DIRECT_DEBIT') {
            return {
              display: {
                blocks: {
                  banks: {
                    instruments: [{ method: 'fpx', banks: [code] }],
                  },
                },
                sequence: ['block.banks'],
                preferences: {
                  show_default_blocks: false
                }
              }
            };
          }
          return {};
        };

        const options = {
          key: razorpay_key_id,
          amount: amount * 100,
          currency: store.getters.getMerchant.base_currency_code || "MYR",
          name: store.getters.getMerchant.name,
          image: store.getters.getMerchant.image_url,
          description: invoice_no,
          order_id: razorpay_order_id,
          ...(channel === 'DIRECT_DEBIT' && {
            callback_url: `${BASE_API}razorpay/fe-notify/${reference_id}`,
            redirect: true
          }),
          prefill: {
            method: channel === 'CREDIT_CARD' ? 'card' : 'fpx',
            name: `${first_name} ${last_name}`.trim(),
            email: email,
            contact: phone_number,
          },
          notes: {
            reference_id: reference_id
          },
          handler: function (response) {
            handleRedirect('success');
          },
          modal: {
            ondismiss: function () {
              if(module === 'RESERVATION_BILL') {
                handleRedirect();
                return;
              }

              const { cancel: { module: api_module, url: api_url } } = getRedirectConfig();
              post(api_module, `${api_url}?merchant_id=${store.getters.getMerchant.id}`).then(() => {
                handleRedirect();
              });
            }
          },
          theme: {
            color: store.getters.getMerchant.primary_color
          },
          config: buildCheckoutConfig()
        };
        console.log("🚀 ~ options:", options)

        const rzp = new Razorpay(options);
        rzp.open();
      };
    });

  },
  $roundPriceByCurrency: (value) => {
    const numericValue = Number(value)
    if (isNaN(numericValue)) return value

    const { base_currency_code: baseCurrencyCode } = store.getters.getMerchant
    if (baseCurrencyCode !== 'IDR') return numericValue

    // Round up so the charge never falls below the BE minimum; trim float noise to cents first.
    const centValue = Math.round(numericValue * CENT_FACTOR) / CENT_FACTOR
    return Math.ceil(centValue)
  },
  $parsingHotelStatusText: (status) => {
    switch (status) {
      case 'COMPLETE':
        return 'Booking Confirmed';
      case 'CANCELLED':
        return 'Cancelled';
      case 'WAITING_PAYMENT_CONFIRMATION':
        return 'Awaiting Payment';
      case 'WAITING_CONFIRMATION':
        return 'Verifying Payment';
      case 'NO_SHOW':
        return 'No Show Pending';
      default:
        return status;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/vuePrototype.js